import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';

import { openPDF } from '../../../common/function';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import { messages } from '../../../common/messages';
import { EXAM_NAMES, examNameAccordingToDB } from '../../../common/constant';
import QuestionModeSetting from '../../../Components-2025/QuestionModeSetting';
/* eslint-disable */

class Cfa3QuestionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      chapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      lastRecord: '',
      hasAnyLastAttemptedQuestion: false,
      dropdownOpen: false,
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      selectedmenu: 'cfa_3',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = { router: React.PropTypes.object };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  toggleAlert() {
    this.setState({ alert_status: !this.state.alert_status });
  }

  // eslint-disable-next-line id-length, no-unused-vars
  _getCases = (chapter, e) => {
    this.context.router.push({
      pathname: `/cfa3/cases/${chapter.id}/${chapter.chapter_name}/${chapter.total_cases}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter,
      },
    });
  };

  componentDidMount() {
    window.scroll(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frm/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(`${App_data.backend_api}/cfa_3question_bank/getChapters`, data).then(
      async (resp) => {
        const { success, chapters } = resp;
        if (success) {
          this.setState({ chapters });
          await FD.callAPI(
            `${App_data.backend_api}/cfa_3question_bank/getlastAnsweredQuestion`,
            data,
          ).then((response) => {
            if (response.success) {
              this.setState({
                lastRecord: response.data,
                hasAnyLastAttemptedQuestion: true,
              });
            }
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }
  redirectToQuestion = () => {
    const { lastRecord, hasAnyLastAttemptedQuestion } = this.state;
    let questionTableKey = 'cfa3_question';
    if (hasAnyLastAttemptedQuestion) {
      if (Object.keys(lastRecord.cfa3_2025_question || {}).length !== 0) {
        questionTableKey = 'cfa3_2025_question';
      }
      this.context.router.push({
        pathname: `/cfa3/chapter/${lastRecord[questionTableKey].chapter_id}/${
          lastRecord[questionTableKey].case_id
        }/${lastRecord.caseIndex}/${lastRecord[questionTableKey].question_number}/${0}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          reading: lastRecord[questionTableKey],
          chapter: lastRecord[questionTableKey].chapter_id,
          offset: 0,
        },
      });
    }
  };

  getAdditionalResources = (type) => {
    const { token, idname } = this.state;
    const typeNames = {
      FS: 'Formula sheet',
      ES: 'Essential summary',
      RS: 'Ratio sheet',
    };
    const typeName = typeNames[type];
    const data = {
      token,
      idname,
      type: typeName,
      exam: examNameAccordingToDB.CFA_LEVEL_3,
    };
    FD.callAPI(`${App_data.backend_api}/cfa_2_2023question_bank/getAdditionalResources`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          openPDF(resp);
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };
  checkSubscription = (type) => {
    const user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, user_data).then((resp) => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          const subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;
          this.setState({
            subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          const selectedExams = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: selectedExams,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            async (exam) => {
              const { success, examData } = exam;
              if (success) {
                const exam_data = examData;
                const selectedmen = this.state.selectedmenu;
                let isSubscribed = false;
                const examPlanData = exam.examPlan[0];
                isSubscribed = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isSubscribed) {
                  this.getAdditionalResources(type);
                } else {
                  this.toggleAlert();
                }
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          const subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          const selectedExams = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: selectedExams,
          };
          FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            (resp_exam) => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                const selectedmen = this.state.selectedmenu;
                let isSubscribed = false;

                isSubscribed = Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isSubscribed) {
                  this.getAdditionalResources(type);
                } else {
                  this.toggleAlert();
                }
              }
            },
          );
        }
      }
    });
  };

  render() {
    const { chapters } = this.state;
    const { hasAnyLastAttemptedQuestion } = this.state;
    let data = '';
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => {
        if (item.total_cases !== 0) {
          return (
            <div
              className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'
              key={index}
            >
              <div
                className='question_bank_wrap pointer_class'
                key={item.id}
                // eslint-disable-next-line no-underscore-dangle
                onClick={this._getCases.bind(this, item)}
              >
                <div className='margin_bottom_30'>
                  <img
                    src={`${App_data.frontend_url}/img/question_bank/icon2.svg`}
                    width='54'
                    className=''
                    alt=''
                  />
                </div>

                <div className='question_title' key={item.id} value={item.id}>
                  <a className='pointer_class' id={item.chapter_name} value={item.chapter_no}>
                    {index + 1}. {item.chapter_name}
                  </a>
                </div>

                <ul key={item.chapter_name}>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/free_question_icon.svg`}
                        className=''
                        width='26'
                        alt=''
                      />
                    </span>
                    <span>{item.free_cases}</span>
                    <div className='tootip_box'> {language.LC().FREE_CASES} </div>
                  </li>
                  <li>
                    <span>
                      <img
                        src={`${App_data.frontend_url}/img/question_bank/premium_question_icon.svg`}
                        className=''
                        width='23'
                        alt=''
                      />
                    </span>
                    <span>{item.total_cases}</span>
                    <div className='tootip_box'> {language.LC().PREMIUM_CASES} </div>
                  </li>
                </ul>
              </div>
            </div>
          );
        }
      });
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
          <h1 className='section_head'>{language.LC().CFA_LEVEL_III_QUESTION_BANK}</h1>
          <QuestionModeSetting examNameKey={EXAM_NAMES.CFA_3} />
          <div>
            {hasAnyLastAttemptedQuestion && (
              <button
                className='btn btn-primary pointer_class'
                onClick={this.redirectToQuestion}
                disabled={!hasAnyLastAttemptedQuestion}
              >
                {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
              </button>
            )}
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Cfa3QuestionBank;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3QuestionBank/Cfa3QuestionBank.js